import { tss } from 'tss-react';

import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import Button from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Overview/Button';
import ErpRecipeAccordion from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Overview/ErpRecipeAccordion';
import SearchBar from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Overview/SearchBar';
import * as IngredientList from 'types/Recipe/Detail/ErpNew/IngredientList';

type IProps = RecipeErpViewComponentProps & {
	ingredientMapping: IngredientList.Type;
};

const Index = (props: IProps) => {
	const { classes } = useStyles();

	return (
		<fieldset className={classes.container}>
			<div className={classes.actionBar}>
				<Button {...props} ingredientMapping={props.ingredientMapping} />
				<SearchBar {...props} ingredientMapping={props.ingredientMapping} />
			</div>
			<ErpRecipeAccordion {...props} />
		</fieldset>
	);
};

export default Index;

const useStyles = tss.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: '15px',
	},
	actionBar: {
		display: 'flex',
		gap: '15px',
	},
});
